import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

interface TopTollPlazasCardSkeletonProps {
  items?: number;
}

const TITLE_LINE_HEIGHT = 29;
const SUBTITLE_LINE_HEIGHT = 23;
const NAME_LINE_HEIGHT = 23;
const CONCESSIONARIA_LINE_HEIGHT = 20;
const COUNT_LINE_HEIGHT = 29;
const BADGE_SIZE = 28;

const ROW_BORDER_STYLE = { borderBottom: "1px solid #E5EBF0" } as const;

const NAME_WIDTHS = ["72%", "58%", "84%", "64%", "76%"];
const CONCESSIONARIA_WIDTHS = ["44%", "36%", "52%", "40%", "48%"];

export default function TopTollPlazasCardSkeleton({ items = 5 }: Readonly<TopTollPlazasCardSkeletonProps>) {
  return (
    <Card className="padding-y-25 padding-x-15 padding-x-25-sm">
      <div className="display-flex flex-column gap-5 padding-bottom-20">
        <span className="text-size-20 text-bold">
          <ContentLoader className="display-block" height={TITLE_LINE_HEIGHT} width={240} />
        </span>
        <span className="text-size-16 text-color-gray">
          <ContentLoader className="display-block" height={SUBTITLE_LINE_HEIGHT} width={320} />
        </span>
      </div>

      <div className="display-flex flex-column">
        {Array.from({ length: items }, (_, index) => (
          <div key={index} className="display-flex align-items-center gap-15 padding-y-15" style={ROW_BORDER_STYLE}>
            <ContentLoader className="flex-0" type={ContentLoader.CIRCLE} radius={BADGE_SIZE / 2} />
            <div className="display-flex flex-column flex-1-1 min-width-0">
              <span className="text-size-16">
                <ContentLoader
                  className="display-block"
                  height={NAME_LINE_HEIGHT}
                  width={NAME_WIDTHS[index % NAME_WIDTHS.length]}
                />
              </span>
              <span className="text-color-gray text-size-14">
                <ContentLoader
                  className="display-block"
                  height={CONCESSIONARIA_LINE_HEIGHT}
                  width={CONCESSIONARIA_WIDTHS[index % CONCESSIONARIA_WIDTHS.length]}
                />
              </span>
            </div>
            <span className="text-size-20 text-color-rating-5 flex-0">
              <ContentLoader className="display-block" height={COUNT_LINE_HEIGHT} width={40} />
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
}
